<template>
  <div class="payslips tile">
    <div class="tile__header mb--4" :style="'background: #3d7bf2'">
      <h3>Payslips</h3>
      <img class="tile__header__image" :src="require('../assets/icons/wallet.svg')" />
    </div>
    <div class="container text--center">
      <p v-if="payslipData.length">Click on a payslip to download.</p>
      <p v-else>There are no payslips to display</p>
      <div class="payslips__table">
      <ui-loading :loading="loading" />
        <table v-if="payslipData.length" class="mdl-data-table mdl-js-data-table m--auto w--100">
          <thead>
            <tr>
              <th>Date</th>
              <th>Gross Pay</th>
              <th>Net Pay</th>
              <th>Tax Period</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="data in payslipData" :key="data.id" @click="openUrl(data.payslip_url)">
              <td>{{data.payslip_date}}</td>
              <td>{{data.gross_pay}}</td>
              <td>{{data.net_pay}}</td>
              <td>{{data.tax_period}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { getPayslips } from 'ewage-portal-files'
import UiLoading from '../components/UILoading'

export default {
  name: 'payslips',
  components: { UiLoading },
  data: () => ({
    loading: false,
    payslips: [],
    payslipData: [],
    errorMessage: null,
  }),
  methods: {
    toggleMenu () {
      this.showMenu = !this.showMenu
    },
    openUrl (url) {
      if (this.$matomo) {
        this.$matomo.trackEvent('Payslips', 'Payslip', 'Payslips Table')
      }
          
      window.open(url)
    }
  },
  async mounted () {
    this.loading = true
    let { payslips, records, error } = await getPayslips(this.$store.getters.user.client_id, this.$store.getters.user.id)
    this.payslips = payslips
    this.payslipData = records
    this.errorMessage = error
    this.loading = false
  },
}
</script>

<style lang="scss" scoped>
table {
  tbody {
    tr {
      cursor: pointer;
    }
  }
}
</style>
